var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbnailAllOfMeLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 572,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 572,
    fill: "#b6b3a7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4.000000) translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#000036",
    fillOpacity: 0.501961,
    points: "16,158 10,87 61,120"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#010000",
    fillOpacity: 0.501961,
    points: "131,60 107,14 99,88"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "-16,-16 130,118 -16,86"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#201734",
    fillOpacity: 0.501961,
    points: "202,133 180,158 91,120"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f2e9d6",
    fillOpacity: 0.501961,
    points: "224,143 252,91 122,28"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000031",
    fillOpacity: 0.501961,
    points: "13,94 17,158 42,102"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f3f4e6",
    fillOpacity: 0.501961,
    points: "70,158 36,117 105,28"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#151a02",
    fillOpacity: 0.501961,
    points: "259,46 271,-2 230,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545d47",
    fillOpacity: 0.501961,
    points: "271,114 224,106 250,158"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2b0100",
    fillOpacity: 0.501961,
    points: "104,17 111,83 130,54"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dccfbe",
    fillOpacity: 0.501961,
    points: "188,-10 163,158 110,-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#959197",
    fillOpacity: 0.501961,
    points: "194,101 228,30 79,130"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#424f2e",
    fillOpacity: 0.501961,
    points: "91,-5 88,29 68,23"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdffee",
    fillOpacity: 0.501961,
    points: "6,139 -16,126 15,57"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6a745a",
    fillOpacity: 0.501961,
    points: "174,52 244,52 229,74"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f9f4e8",
    fillOpacity: 0.501961,
    points: "220,86 240,156 168,51"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3d3f26",
    fillOpacity: 0.501961,
    points: "224,4 218,20 241,24"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2a2e6b",
    fillOpacity: 0.501961,
    points: "33,118 68,119 58,129"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#050000",
    fillOpacity: 0.501961,
    points: "131,130 160,158 149,127"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#002460",
    fillOpacity: 0.501961,
    points: "48,158 9,121 31,92"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#544b43",
    fillOpacity: 0.501961,
    points: "22,19 61,14 25,6"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffea",
    fillOpacity: 0.501961,
    points: "161,9 82,10 174,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dc813b",
    fillOpacity: 0.501961,
    points: "113,81 103,21 94,91"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#803716",
    fillOpacity: 0.501961,
    points: "147,39 145,21 130,15"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6f5865",
    fillOpacity: 0.501961,
    points: "159,136 206,108 200,133"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c7c7d3",
    fillOpacity: 0.501961,
    points: "147,39 201,141 122,88"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eeedd3",
    fillOpacity: 0.501961,
    points: "234,6 266,21 226,17"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#edf6f9",
    fillOpacity: 0.501961,
    points: "21,47 73,42 4,101"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d4976b",
    fillOpacity: 0.501961,
    points: "103,9 136,9 122,45"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ebf1db",
    fillOpacity: 0.501961,
    points: "270,97 242,71 159,120"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7e86a2",
    fillOpacity: 0.501961,
    points: "124,150 146,90 118,63"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f9f9db",
    fillOpacity: 0.501961,
    points: "73,23 97,57 92,117"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000500",
    fillOpacity: 0.501961,
    points: "261,30 271,19 234,21"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0f0b05",
    fillOpacity: 0.501961,
    points: "124,64 110,16 105,66"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#111904",
    fillOpacity: 0.501961,
    points: "218,34 215,56 212,47"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#764937",
    fillOpacity: 0.501961,
    points: "181,91 188,104 201,92"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f6fdff",
    fillOpacity: 0.501961,
    points: "9,15 31,95 37,25"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e9e2c9",
    fillOpacity: 0.501961,
    points: "246,125 249,110 224,127"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#001633",
    fillOpacity: 0.501961,
    points: "45,106 25,94 7,107"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#122211",
    fillOpacity: 0.501961,
    points: "93,31 87,36 89,47"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#454d46",
    fillOpacity: 0.501961,
    points: "262,108 264,141 225,153"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e5e6d0",
    fillOpacity: 0.501961,
    points: "39,118 99,80 123,116"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a5a987",
    fillOpacity: 0.501961,
    points: "214,90 176,14 221,62"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#77754c",
    fillOpacity: 0.501961,
    points: "186,9 220,22 188,21"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e9ebcd",
    fillOpacity: 0.501961,
    points: "227,20 244,58 221,50"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#725248",
    fillOpacity: 0.501961,
    points: "101,65 123,62 121,93"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8a8d9e",
    fillOpacity: 0.501961,
    points: "53,123 29,120 44,139"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2a1a3a",
    fillOpacity: 0.501961,
    points: "146,129 160,117 150,121"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0f221b",
    fillOpacity: 0.501961,
    points: "186,60 202,59 187,52"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cfcc94",
    fillOpacity: 0.501961,
    points: "84,2 4,-16 -13,17"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ded5bd",
    fillOpacity: 0.501961,
    points: "30,17 64,15 101,63"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1f2a7a",
    fillOpacity: 0.501961,
    points: "200,158 164,136 190,130"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#efefcc",
    fillOpacity: 0.501961,
    points: "198,33 217,25 209,52"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f7ffe4",
    fillOpacity: 0.501961,
    points: "16,134 1,104 -16,127"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6e6487",
    fillOpacity: 0.501961,
    points: "131,120 91,128 86,116"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e1b98e",
    fillOpacity: 0.501961,
    points: "117,39 115,17 146,65"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#bcb891",
    fillOpacity: 0.501961,
    points: "-16,54 11,83 9,42"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eef5e6",
    fillOpacity: 0.501961,
    points: "186,34 139,53 169,60"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ceb69f",
    fillOpacity: 0.501961,
    points: "33,74 48,93 79,71"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eed7d1",
    fillOpacity: 0.501961,
    points: "140,117 155,134 144,103"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e1e9dd",
    fillOpacity: 0.501961,
    points: "98,126 47,130 46,158"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3b3c34",
    fillOpacity: 0.501961,
    points: "197,52 203,40 195,43"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#263435",
    fillOpacity: 0.501961,
    points: "221,65 233,54 239,59"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00224f",
    fillOpacity: 0.501961,
    points: "27,158 35,98 8,110"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#43421f",
    fillOpacity: 0.501961,
    points: "267,15 271,61 251,52"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#333d35",
    fillOpacity: 0.501961,
    points: "83,29 66,17 87,19"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e5e6e0",
    fillOpacity: 0.501961,
    points: "222,68 204,51 224,61"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3a313f",
    fillOpacity: 0.501961,
    points: "139,117 141,110 121,110"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d09562",
    fillOpacity: 0.501961,
    points: "172,71 203,93 169,83"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0b1100",
    fillOpacity: 0.501961,
    points: "264,17 241,36 265,27"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#25291a",
    fillOpacity: 0.501961,
    points: "239,-13 247,15 255,10"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e5f4fa",
    fillOpacity: 0.501961,
    points: "49,107 44,88 12,81"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffef",
    fillOpacity: 0.501961,
    points: "60,31 42,82 65,56"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e5d0c8",
    fillOpacity: 0.501961,
    points: "202,158 202,90 243,153"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99936b",
    fillOpacity: 0.501961,
    points: "50,50 58,33 39,35"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a49278",
    fillOpacity: 0.501961,
    points: "84,43 67,34 72,63"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#bebd9c",
    fillOpacity: 0.501961,
    points: "70,121 75,158 126,130"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a1b0c3",
    fillOpacity: 0.501961,
    points: "184,85 129,108 118,76"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#211a0e",
    fillOpacity: 0.501961,
    points: "175,133 170,131 181,121"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#693d1f",
    fillOpacity: 0.501961,
    points: "196,114 199,120 179,121"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b5b08a",
    fillOpacity: 0.501961,
    points: "68,-16 64,13 114,20"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffe5ba",
    fillOpacity: 0.501961,
    points: "102,5 103,51 95,27"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d4cfbb",
    fillOpacity: 0.501961,
    points: "117,89 76,114 122,110"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9da177",
    fillOpacity: 0.501961,
    points: "187,10 171,46 173,14"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#29320e",
    fillOpacity: 0.501961,
    points: "215,59 212,70 207,67"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#323934",
    fillOpacity: 0.501961,
    points: "37,6 55,-15 35,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#040600",
    fillOpacity: 0.501961,
    points: "110,37 130,51 115,61"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ecdcc9",
    fillOpacity: 0.501961,
    points: "119,29 142,26 146,57"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#daddbe",
    fillOpacity: 0.501961,
    points: "201,24 140,42 172,14"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e6e5bf",
    fillOpacity: 0.501961,
    points: "62,-5 69,19 41,4"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4b4936",
    fillOpacity: 0.501961,
    points: "222,23 230,3 217,11"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#989c6f",
    fillOpacity: 0.501961,
    points: "151,15 162,22 172,1"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f8f7d7",
    fillOpacity: 0.501961,
    points: "225,22 238,32 248,26"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b7b8a9",
    fillOpacity: 0.501961,
    points: "247,22 271,9 253,3"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fdffff",
    fillOpacity: 0.501961,
    points: "75,23 88,42 70,29"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "145,124 132,119 141,117"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#463d47",
    fillOpacity: 0.501961,
    points: "26,14 55,14 46,8"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f1f8eb",
    fillOpacity: 0.501961,
    points: "96,87 69,124 58,82"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f8fef1",
    fillOpacity: 0.501961,
    points: "261,97 205,85 196,101"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#656e94",
    fillOpacity: 0.501961,
    points: "162,99 136,100 152,94"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailAllOfMeLow);
export default __webpack_public_path__ + "static/media/thumbnail_all_of_me_low.e55e69a6ddbc500fa32f45a202c68580.svg";
export { ForwardRef as ReactComponent };